import * as React from 'react'
import styled from 'styled-components'
import tw from 'tailwind.macro'
import { Parallax } from 'react-spring/renderprops-addons.cjs'
import { graphql } from 'gatsby'

// Components
import Layout from '../components/Layout'
import ProjectCard from '../components/ProjectCard'

// Elements
import Inner from '../elements/Inner'
import { Title, BigTitle, Subtitle } from '../elements/Titles'

// Views
import Hero from '../views/Hero'
import Projects from '../views/Projects'
import About from '../views/About'
import Contact from '../views/Contact'

import avatar from '../images/avatar.jpg'

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(3, 1fr);
  // grid-auto-rows: 2fr;
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`

const Avatar = styled.img`
  ${tw`rounded-full w-32 xl:w-48 shadow-lg h-auto`};
`

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`

const AboutDesc = styled.p`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`

const ContactText = styled.p`
  ${tw`text-grey-light font-sans text-xl md:text-2xl lg:text-3xl`};
`

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 font-sans text-md lg:text-lg`};
`

class Index extends React.Component {
  render() {
    const { data } = this.props
    return (
      <>
        <Layout />
        <Parallax pages={5}>
          <Hero offset={0}>
            <BigTitle>
              Hello, <br /> I’m Robert Rouse.
        </BigTitle>
            <Subtitle>I work at the intersection of data and design, crafting beauty in back-end architectures and front-end experiences.</Subtitle>
          </Hero>
          <Projects offset={1} >
            <Title>Projects</Title>
            <ProjectsWrapper>
              { data.allProjectsYaml.edges.map(project => (
                <>
                  <ProjectCard
                    title={project.node.title}
                    link={project.node.url}
                    bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
                    thumb={project.node.thumb.childImageSharp.fluid}
                    tools={project.node.tools}
                    description={project.node.description}
                  />
                </>
              ))}
            </ProjectsWrapper>
          </Projects>
          <About offset={3}>
            <Title>About</Title>
            <AboutHero>
              <Avatar src={avatar} alt="Robert Rouse" />
              <AboutSub>
                We all have problems. I enjoy collaborating with people eager to find creative solutions.
          </AboutSub>
            </AboutHero>
            <AboutDesc>
              I’m an Air Force Academy graduate, former Tableau Zen Master, and analytics consultant.
              You could call me a data artist, a designer who codes, or an engineer who understands design.
              Mainly, I simplify complex things in our digital world.
        </AboutDesc>
          </About>
          <Contact offset={4}>
            <Inner>
              <Title>Get in touch</Title>
              <ContactText>
                Send me an <a href="mailto:robert@viz.bible">e-mail</a> or find me on {' '}
                <a href="https://twitter.com/bibleviz">Twitter</a>{', '}
                <a href="https://dribbble.com/bibleviz">Dribbble</a>{', and '}
                <a href="https://www.linkedin.com/in/robert-rouse-a3812b10/">LinkedIn</a>
              </ContactText>
            </Inner>
            <Footer>
              &copy; 2019 by Gatsby Starter Portfolio Cara.{' '}
              <a href="https://github.com/LekoArts/gatsby-starter-portfolio-cara">Github Repository</a>. Made by{' '}
              <a href="https://www.lekoarts.de">LekoArts</a> with customizations by Robert Rouse.
        </Footer>
          </Contact>
        </Parallax>
      </>
    )
  }
}

export default Index

export const projectsQuery = graphql`
  query projectsQuery {
    allProjectsYaml {
      edges {
        node {
          id
          title
          url
          description
          tools
          thumb {
            childImageSharp {
              fluid(maxWidth: 650) {
                ...GatsbyImageSharpFluid_withWebp
              }
            }
          }
        }
      }
    }
  }
`